<script lang="ts" setup>
import { onMounted, useTemplateRef } from '#imports';
import type { MsgVO } from '~/types/im';
import { watchElementVisible } from '../../composables/watch-element-visible';
import ImMsgBase from './ImMsgBase.vue';

interface Props {
  msg: MsgVO;
}

const { msg } = defineProps<Props>();
const txtRef = useTemplateRef('txt');

const emit = defineEmits(['read']);

function handleRead() {
  emit('read');
}

onMounted(() => {
  if (!msg.isMine && msg.readStatus === 0) {
    watchElementVisible(txtRef, handleRead);
  }
});
</script>

<template>
  <ImMsgBase
    :recall="msg.msgBody.recall"
    :avatar="msg.avatar"
    :show-datetime="msg.showDatetime"
    :time="msg.msgTime"
    :placement="msg.placement"
    :loading="msg.loading"
    :error="msg.error"
  >
    <div ref="txt" class="whitespace-pre-wrap break-words">
      【不支持的消息类型，请前往客户端查看】
    </div>
  </ImMsgBase>
</template>

<style scoped></style>
